export interface ValueDisplayDefaultFieldNames {
  valueField: string;
  displayField: string;
}
